export * from './BaseGenericModal'
export * from './BaseGenericModal.types';